'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var react = require('@chakra-ui/react');
var logger = require('../utils/logger.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);

// @TODO: Unit test.
// For whatever reason fails when copied 1:1 from
// https://github.com/hausgold/designsystem/blob/migrate-to-chakra/testing/__tests__/hooks/useBreakpoint.jsx

/**
 * Provides a simple way to get the current breakpoint range from screen size.
 * This hook is a wrapper of `chakra-ui`'s `useMediaQuery` which relies on `window.matchMedia`.
 */
var useBreakpoint = function useBreakpoint(breakpoint) {
  var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '>';
  var _useTheme = react.useTheme(),
    themeBreakpoints = _useTheme.breakpoints;
  var breakpointValue = themeBreakpoints[breakpoint];
  var comparatorString = comparator === '>' ? 'min' : 'max';
  var _useMediaQuery = react.useMediaQuery("(".concat(comparatorString, "-width: ").concat(breakpointValue, ")")),
    _useMediaQuery2 = _slicedToArray__default["default"](_useMediaQuery, 1),
    isWithinMediaBreakpoint = _useMediaQuery2[0];
  if (!breakpointValue) {
    logger.error('The given breakpoint key can not be found in the theme.', 'useBreakpoint', !breakpointValue);
    return false;
  }
  return isWithinMediaBreakpoint;
};
exports.useBreakpoint = useBreakpoint;